module.exports = __webpack_public_path__ + "img/1577434692.69009955.jpg";